export const categories = [
  { id: "all", name: "全部", icon: "ri-apps-2-line" },
  { id: "hot", name: "热点突发", icon: "ri-fire-line" },
  { id: "ent", name: "娱乐圈", icon: "ri-star-smile-line" },
  { id: "society", name: "社会万象", icon: "ri-earth-line" },
  { id: "tech", name: "科技前沿", icon: "ri-cpu-line" },
  { id: "life", name: "生活趣闻", icon: "ri-leaf-line" },
  { id: "talk", name: "影视解说", icon: "ri-movie-2-line" },
];

export const speedFeatures = [
  {
    icon: "ri-flashlight-line",
    title: "秒开加载",
    desc: "自研预加载策略，点开即播，平均首帧时间控制在 0.3 秒以内。",
    metric: "0.3s",
    metricLabel: "平均首帧",
  },
  {
    icon: "ri-hd-line",
    title: "超清画质",
    desc: "最高支持 4K 超清，智能码率自适应，网络波动也不掉画质。",
    metric: "4K",
    metricLabel: "最高清晰度",
  },
  {
    icon: "ri-speed-up-line",
    title: "流畅不卡顿",
    desc: "多线路智能切换，弱网环境下自动降码保流畅，全程几乎无缓冲。",
    metric: "99.9%",
    metricLabel: "播放成功率",
  },
  {
    icon: "ri-device-line",
    title: "多端同步",
    desc: "手机、平板、电脑进度实时同步，换设备也能接着看。",
    metric: "3 端",
    metricLabel: "无缝续播",
  },
];

export const rankings = [
  { id: "c-01", title: "城市夜空灯光秀刷屏：无人机组画出整条星河", categoryName: "热点突发", hot: 9860, views: "286.5万" },
  { id: "c-07", title: "暴雨中的逆行者：骑手护送老人蹚过积水路段", categoryName: "热点突发", hot: 9570, views: "163.9万" },
  { id: "c-06", title: "五分钟看懂年度悬疑片：结局的细节全在这里", categoryName: "影视解说", hot: 9340, views: "221.8万" },
  { id: "c-02", title: "新剧开播首日冲上热搜，主创团队回应观众热议", categoryName: "娱乐圈", hot: 9210, views: "192.3万" },
  { id: "c-04", title: "国产折叠屏新机上手实测：铰链与续航表现亮眼", categoryName: "科技前沿", hot: 8830, views: "134.2万" },
  { id: "c-09", title: "AI 修图实测：一键还原老照片里的细节", categoryName: "科技前沿", hot: 8640, views: "112.4万" },
  { id: "c-08", title: "音乐节收官夜现场：全场合唱的画面太治愈", categoryName: "娱乐圈", hot: 8120, views: "98.6万" },
  { id: "c-03", title: "早市里的手艺人：一把剪刀守了三十年", categoryName: "社会万象", hot: 7450, views: "88.7万" },
];

export const faqs = [
  {
    q: "看视频总是卡顿、转圈，是什么原因？",
    a: "大多数卡顿来自网络抖动或线路拥堵。看料社会自动在多个节点间切换，弱网时优先保证流畅度。你也可以在播放器右下角手动切换清晰度，或切换到延迟更低的线路。",
  },
  {
    q: "为什么有的内容清晰度只能到 1080P？",
    a: "清晰度取决于原始素材的上传规格。我们会对所有内容做画质增强，但不会强行插值到 4K，以免出现失真。标注为 4K 的内容均为原生或高质量修复版本。",
  },
  {
    q: "需要注册账号才能观看吗？",
    a: "浏览与观看不需要注册。账号仅用于多端同步观看进度、收藏内容以及订阅你感兴趣的分类更新，这些功能都是可选的。",
  },
  {
    q: "内容多久更新一次？",
    a: "热点与突发类内容实时跟进，其余分类每天更新。你可以在分类页按「最新发布」排序，看到的顺序就是更新时间顺序。",
  },
  {
    q: "在手机上流量消耗大吗？",
    a: "播放器会默认根据网络类型选择合适码率。在移动网络下建议使用「智能清晰度」，可以明显降低流量消耗，同时保持观看体验。",
  },
];

export const testimonials = [
  {
    name: "林一舟",
    role: "内容运营",
    avatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20a%20young%20Chinese%20professional%20smiling%20gently%20against%20a%20warm%20beige%20studio%20background%2C%20editorial%20headshot%20photography%2C%20soft%20natural%20light%2C%20high%20detail%2C%20no%20text&width=200&height=200&seq=kanliao-user-01&orientation=squarish",
    quote: "追热点最怕加载慢，看料社几乎是点开就播，开会前用手机刷两分钟也够用，节奏完全跟得上。",
  },
  {
    name: "周沐",
    role: "在校学生",
    avatar: "https://readdy.ai/api/search-image?query=Cheerful%20portrait%20of%20a%20young%20Chinese%20student%20with%20short%20hair%20against%20a%20soft%20cream%20background%2C%20editorial%20headshot%20photography%2C%20warm%20lighting%2C%20high%20detail%2C%20no%20text&width=200&height=200&seq=kanliao-user-02&orientation=squarish",
    quote: "分类做得很清楚，想看的解说和现场各归各位，不用在信息流里翻来翻去，找内容省了不少时间。",
  },
  {
    name: "陈以宁",
    role: "自由设计师",
    avatar: "https://readdy.ai/api/search-image?query=Calm%20portrait%20of%20a%20Chinese%20woman%20designer%20with%20glasses%20against%20a%20warm%20neutral%20background%2C%20editorial%20headshot%20photography%2C%20soft%20window%20light%2C%20high%20detail%2C%20no%20text&width=200&height=200&seq=kanliao-user-03&orientation=squarish",
    quote: "画质是真不错，夜景和暗部细节都保住了，用电脑投影看也不会糊，这点很难得。",
  },
];

export const siteStats = [
  { value: "0.3", unit: "秒", label: "平均首帧时间" },
  { value: "99.9", unit: "%", label: "播放成功率" },
  { value: "4K", unit: "", label: "最高清晰度" },
  { value: "1200", unit: "万+", label: "累计观看人次" },
];

export const featuredSpotlight = {
  id: "c-01",
  kicker: "本周焦点",
  image:
    "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20cityscape%20with%20a%20drone%20light%20show%20forming%20a%20glowing%20galaxy%20above%20modern%20towers%2C%20warm%20amber%20city%20lights%20reflecting%20on%20water%2C%20stylized%20editorial%20photography%2C%20deep%20charcoal%20and%20warm%20gold%20tones%2C%20soft%20haze%2C%20high%20detail%2C%20no%20text&width=1200&height=760&seq=kanliao-spotlight&orientation=landscape",
};

export const brandImage =
  "https://readdy.ai/api/search-image?query=Warm%20minimalist%20creative%20studio%20corner%20with%20a%20wooden%20desk%2C%20monitor%20editing%20setup%2C%20green%20plants%20and%20soft%20daylight%20through%20linen%20curtains%2C%20editorial%20interior%20photography%2C%20warm%20neutral%20beige%20tones%2C%20calm%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1000&height=800&seq=kanliao-brand&orientation=landscape";

export const heroBackground =
  "https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20stage%20with%20flowing%20warm%20vermillion%20and%20amber%20light%20trails%2C%20soft%20grain%20texture%2C%20deep%20charcoal%20background%2C%20cinematic%20gradient%20mesh%2C%20artistic%20wallpaper%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=kanliao-hero&orientation=landscape";

export const marqueeWords = [
  "秒开加载",
  "4K 超清",
  "智能线路",
  "弱网优化",
  "多端续播",
  "几乎零缓冲",
  "实时跟热点",
  "画质增强",
];